/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TariffStatus = {
    Draft: 'Draft',
    Active: 'Active',
    Archived: 'Archived'
} as const;
export type TariffStatus = typeof TariffStatus[keyof typeof TariffStatus];

